/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { OrgV4Subscriptions } from '../model/orgV4Subscriptions';
// @ts-ignore
import { SubscriptionDisplayPaginatedResponse } from '../model/subscriptionDisplayPaginatedResponse';
// @ts-ignore
import { SubscriptionRegionsResponseSpec } from '../model/subscriptionRegionsResponseSpec';
// @ts-ignore
import { SubscriptionStateEnum } from '../model/subscriptionStateEnum';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';



@Injectable({
  providedIn: 'root'
})
export class CommerceVmcfsService extends BaseService {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Get all vmcfs subscription display by org id.
     * Get all vmcfs subscription display by org id.
     * @param orgId Organization identifier
     * @param sortBy Sort the subscription display by this column
     * @param sortByOrder Sort the properties by this order
     * @param idOptionalQueryParam Long ID query param
     * @param serialNumberQueryParamOptional Subscription Serial Number In Optional Filter
     * @param startDateStartOptionalQueryParam Start date to begin with in YYYY-MM-DD
     * @param startDateEndOptionalQueryParam Start date to end with in YYYY-MM-DD
     * @param endDateStartOptionalQueryParam End date to begin with in YYYY-MM-DD
     * @param endDateEndOptionalQueryParam End date to end with in YYYY-MM-DD
     * @param quantityQueryParamOptional Quantity In Optional Filter
     * @param subscriptionStateOptionalQueryParam Subscription state
     * @param createdTsStart Filter for created ts start
     * @param createdTsEnd Filter for created ts end
     * @param updatedTsStart Filter for updated ts start
     * @param updatedTsEnd Filter for updated ts end
     * @param chargeIdQueryParamOptional Charge Id In Optional Filter
     * @param datacenterQueryParamOptional Datacenter In Optional Filter
     * @param pageNo Page Number (It starts from 0)
     * @param pageSize Page Size
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getSubscriptionDisplayVmcfs(orgId: string, sortBy: 'id' | 'tenantId' | 'serialNumber' | 'startDate' | 'endDate' | 'quantity' | 'state', sortByOrder: 'ASC' | 'DESC', idOptionalQueryParam?: number, serialNumberQueryParamOptional?: string, startDateStartOptionalQueryParam?: string, startDateEndOptionalQueryParam?: string, endDateStartOptionalQueryParam?: string, endDateEndOptionalQueryParam?: string, quantityQueryParamOptional?: number, subscriptionStateOptionalQueryParam?: SubscriptionStateEnum, createdTsStart?: Date, createdTsEnd?: Date, updatedTsStart?: Date, updatedTsEnd?: Date, chargeIdQueryParamOptional?: string, datacenterQueryParamOptional?: string, pageNo?: number, pageSize?: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<SubscriptionDisplayPaginatedResponse>;
    public getSubscriptionDisplayVmcfs(orgId: string, sortBy: 'id' | 'tenantId' | 'serialNumber' | 'startDate' | 'endDate' | 'quantity' | 'state', sortByOrder: 'ASC' | 'DESC', idOptionalQueryParam?: number, serialNumberQueryParamOptional?: string, startDateStartOptionalQueryParam?: string, startDateEndOptionalQueryParam?: string, endDateStartOptionalQueryParam?: string, endDateEndOptionalQueryParam?: string, quantityQueryParamOptional?: number, subscriptionStateOptionalQueryParam?: SubscriptionStateEnum, createdTsStart?: Date, createdTsEnd?: Date, updatedTsStart?: Date, updatedTsEnd?: Date, chargeIdQueryParamOptional?: string, datacenterQueryParamOptional?: string, pageNo?: number, pageSize?: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<SubscriptionDisplayPaginatedResponse>>;
    public getSubscriptionDisplayVmcfs(orgId: string, sortBy: 'id' | 'tenantId' | 'serialNumber' | 'startDate' | 'endDate' | 'quantity' | 'state', sortByOrder: 'ASC' | 'DESC', idOptionalQueryParam?: number, serialNumberQueryParamOptional?: string, startDateStartOptionalQueryParam?: string, startDateEndOptionalQueryParam?: string, endDateStartOptionalQueryParam?: string, endDateEndOptionalQueryParam?: string, quantityQueryParamOptional?: number, subscriptionStateOptionalQueryParam?: SubscriptionStateEnum, createdTsStart?: Date, createdTsEnd?: Date, updatedTsStart?: Date, updatedTsEnd?: Date, chargeIdQueryParamOptional?: string, datacenterQueryParamOptional?: string, pageNo?: number, pageSize?: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<SubscriptionDisplayPaginatedResponse>>;
    public getSubscriptionDisplayVmcfs(orgId: string, sortBy: 'id' | 'tenantId' | 'serialNumber' | 'startDate' | 'endDate' | 'quantity' | 'state', sortByOrder: 'ASC' | 'DESC', idOptionalQueryParam?: number, serialNumberQueryParamOptional?: string, startDateStartOptionalQueryParam?: string, startDateEndOptionalQueryParam?: string, endDateStartOptionalQueryParam?: string, endDateEndOptionalQueryParam?: string, quantityQueryParamOptional?: number, subscriptionStateOptionalQueryParam?: SubscriptionStateEnum, createdTsStart?: Date, createdTsEnd?: Date, updatedTsStart?: Date, updatedTsEnd?: Date, chargeIdQueryParamOptional?: string, datacenterQueryParamOptional?: string, pageNo?: number, pageSize?: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (orgId === null || orgId === undefined) {
            throw new Error('Required parameter orgId was null or undefined when calling getSubscriptionDisplayVmcfs.');
        }
        if (sortBy === null || sortBy === undefined) {
            throw new Error('Required parameter sortBy was null or undefined when calling getSubscriptionDisplayVmcfs.');
        }
        if (sortByOrder === null || sortByOrder === undefined) {
            throw new Error('Required parameter sortByOrder was null or undefined when calling getSubscriptionDisplayVmcfs.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>sortBy, 'sortBy');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>sortByOrder, 'sort-by-order');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>idOptionalQueryParam, 'idOptionalQueryParam');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>serialNumberQueryParamOptional, 'serial-number-query-param-optional');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>startDateStartOptionalQueryParam, 'startDateStartOptionalQueryParam');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>startDateEndOptionalQueryParam, 'startDateEndOptionalQueryParam');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>endDateStartOptionalQueryParam, 'endDateStartOptionalQueryParam');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>endDateEndOptionalQueryParam, 'endDateEndOptionalQueryParam');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>quantityQueryParamOptional, 'quantity-query-param-optional');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>subscriptionStateOptionalQueryParam, 'subscriptionStateOptionalQueryParam');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>createdTsStart, 'createdTsStart');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>createdTsEnd, 'createdTsEnd');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>updatedTsStart, 'updatedTsStart');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>updatedTsEnd, 'updatedTsEnd');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>chargeIdQueryParamOptional, 'charge-id-query-param-optional');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>datacenterQueryParamOptional, 'datacenter-query-param-optional');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>pageNo, 'page-no');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>pageSize, 'page-size');

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vmcfs/org/${this.configuration.encodeParam({name: "orgId", value: orgId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/commerce/subscriptions`;
        return this.httpClient.request<SubscriptionDisplayPaginatedResponse>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get subscription regions
     * Get subscription regions
     * @param orgId Organization identifier
     * @param provider Cloud provider
     * @param regionId Region ID of Cloud Provider
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getVmcfsSubscriptionRegions(orgId: string, provider?: 'AWS' | 'GCP', regionId?: 'ap-east-1' | 'ap-northeast-1' | 'ap-northeast-2' | 'ap-northeast-3' | 'ap-south-1' | 'ap-south-2' | 'ap-southeast-1' | 'ap-southeast-2' | 'ap-southeast-3' | 'ap-southeast-4' | 'af-south-1' | 'eu-central-1' | 'eu-central-2' | 'eu-north-1' | 'eu-south-1' | 'eu-west-1' | 'eu-west-2' | 'eu-west-3' | 'me-central-1' | 'me-south-1' | 'sa-east-1' | 'ca-central-1' | 'us-east-1' | 'us-east-2' | 'us-west-1' | 'us-west-2', observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<SubscriptionRegionsResponseSpec>;
    public getVmcfsSubscriptionRegions(orgId: string, provider?: 'AWS' | 'GCP', regionId?: 'ap-east-1' | 'ap-northeast-1' | 'ap-northeast-2' | 'ap-northeast-3' | 'ap-south-1' | 'ap-south-2' | 'ap-southeast-1' | 'ap-southeast-2' | 'ap-southeast-3' | 'ap-southeast-4' | 'af-south-1' | 'eu-central-1' | 'eu-central-2' | 'eu-north-1' | 'eu-south-1' | 'eu-west-1' | 'eu-west-2' | 'eu-west-3' | 'me-central-1' | 'me-south-1' | 'sa-east-1' | 'ca-central-1' | 'us-east-1' | 'us-east-2' | 'us-west-1' | 'us-west-2', observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<SubscriptionRegionsResponseSpec>>;
    public getVmcfsSubscriptionRegions(orgId: string, provider?: 'AWS' | 'GCP', regionId?: 'ap-east-1' | 'ap-northeast-1' | 'ap-northeast-2' | 'ap-northeast-3' | 'ap-south-1' | 'ap-south-2' | 'ap-southeast-1' | 'ap-southeast-2' | 'ap-southeast-3' | 'ap-southeast-4' | 'af-south-1' | 'eu-central-1' | 'eu-central-2' | 'eu-north-1' | 'eu-south-1' | 'eu-west-1' | 'eu-west-2' | 'eu-west-3' | 'me-central-1' | 'me-south-1' | 'sa-east-1' | 'ca-central-1' | 'us-east-1' | 'us-east-2' | 'us-west-1' | 'us-west-2', observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<SubscriptionRegionsResponseSpec>>;
    public getVmcfsSubscriptionRegions(orgId: string, provider?: 'AWS' | 'GCP', regionId?: 'ap-east-1' | 'ap-northeast-1' | 'ap-northeast-2' | 'ap-northeast-3' | 'ap-south-1' | 'ap-south-2' | 'ap-southeast-1' | 'ap-southeast-2' | 'ap-southeast-3' | 'ap-southeast-4' | 'af-south-1' | 'eu-central-1' | 'eu-central-2' | 'eu-north-1' | 'eu-south-1' | 'eu-west-1' | 'eu-west-2' | 'eu-west-3' | 'me-central-1' | 'me-south-1' | 'sa-east-1' | 'ca-central-1' | 'us-east-1' | 'us-east-2' | 'us-west-1' | 'us-west-2', observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (orgId === null || orgId === undefined) {
            throw new Error('Required parameter orgId was null or undefined when calling getVmcfsSubscriptionRegions.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>provider, 'provider');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>regionId, 'region-id');

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vmcfs/org/${this.configuration.encodeParam({name: "orgId", value: orgId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/commerce/subscription-regions`;
        return this.httpClient.request<SubscriptionRegionsResponseSpec>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Fetch VMCFS subscriptions from ServicePlane and BillingEngine
     * Fetch the subscriptions for the given org
     * @param orgId Organization identifier
     * @param subscriptionType Subscription Type
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getVmcfsSubscriptionsV4(orgId: string, subscriptionType?: 'COMMIT' | 'ONDEMAND', observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<OrgV4Subscriptions>;
    public getVmcfsSubscriptionsV4(orgId: string, subscriptionType?: 'COMMIT' | 'ONDEMAND', observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<OrgV4Subscriptions>>;
    public getVmcfsSubscriptionsV4(orgId: string, subscriptionType?: 'COMMIT' | 'ONDEMAND', observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<OrgV4Subscriptions>>;
    public getVmcfsSubscriptionsV4(orgId: string, subscriptionType?: 'COMMIT' | 'ONDEMAND', observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (orgId === null || orgId === undefined) {
            throw new Error('Required parameter orgId was null or undefined when calling getVmcfsSubscriptionsV4.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>subscriptionType, 'subscription-type');

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vmcfs/org/${this.configuration.encodeParam({name: "orgId", value: orgId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/commerce/v4/subscriptions`;
        return this.httpClient.request<OrgV4Subscriptions>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

}
